<template>
    <div id="app" v-if="flag">
        <!-- 这里是Component的渲染位置 -->
        <!--        <keep-alive include="Portal,Classification,ShoppingCart,My">

            </keep-alive>-->

        <router-view v-wechat-title="$route.meta.title" />
        <Navigation v-if="route && route.meta.isFlag" :route="route"></Navigation>


        <template v-if="$route.name == 'Portal'">
            <!--在服务中心大才弹出车辆绑定（有些店不在服务中心不需要）-->
            <template v-if="$work_ctx.serviceCenter">
                <perfect-vehicle :visible="!isHasVehicle" :title="merchantInfo.name"
                                 @close="confirmPerfectVehicle"></perfect-vehicle>
            </template>
        </template>
    </div>
</template>

<script>
import Navigation from "@/components/pubilc/Navigation";
import PerfectVehicle from "@/components/modal/PerfectVehicle";
import shareConfig from "@/constant/shareConfig";

export default {
    name: 'app',
    components: {
        'Navigation': Navigation,
        'perfect-vehicle' : PerfectVehicle,
    },
    data() {
        return {
            appConfig: null,
            route: null,
            flag: false,
        }

    },

    async created() {
        // 刷新页面时加载 sessionStorage 里的信息
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
        }

        // 在页面刷新时将 vuex 里的信息保存到 sessionStorage 里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        })


        // 禁止双指放大
        document.documentElement.addEventListener('touchstart', function (e) {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        }, false)

        // 禁止页面缩放
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');

        //安卓手机强制禁止用户修改微信客户端的字体大小
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
            this.handleFontSize();
        } else {
            if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", this.handleFontSize, false);
            } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
                document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
            }
        }

        this.checkAccount();
    },


    mounted() {
        console.warn('spa项目初始化');
        this.$nextTick(() => {
            this.initjWxiXinScript();
            this.init();
        })
    },
    
    computed:{
        isHasVehicle(){
            return this.$store.state.memberCarList.length > 0;
        },
        merchantInfo(){
            return this.$store.state.merchantInfo;
        },
    },
    
    watch:{
        $route:{
            handler(val){
                // console.log('~~~~watch-curr-route~~~~', val);
                this.route = val;
            },
        }
    },

    methods: {
        initjWxiXinScript() {
            var that = this;
            // 加载微信SDK
            let wx_script = document.createElement("script");
            wx_script.type = "text/javascript";
            wx_script.src = "//res.wx.qq.com/open/js/jweixin-1.6.0.js";
            wx_script.onload = function (e)
            {
                let url = that.$getWxSignHref();
                var params = {
                    url: url,
                    shareConfigType: shareConfig.ShareConfigType.其它分享标题设置,
                    sceneId: shareConfig.ShareOtherType.首页,
                    subSceneId: 0,
                    shareType: shareConfig.ShareType.None,
                    shareSceneType: shareConfig.ShareSceneType.None,
                };
                that.$http.get('/Merchant/GetJsConfig')
                    .setParameters(params)
                    .success((message, data) => {
                        console.log('GetJsConfig', data);
                        that.appConfig = data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: that.appConfig.appId, // 必填，公众号的唯一标识
                            timestamp: that.appConfig.timeStamp, // 必填，生成签名的时间戳
                            nonceStr: that.appConfig.nonceStr, // 必填，生成签名的随机串
                            signature: that.appConfig.signAture,// 必填，签名
                            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'getLocation', 'openLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'scanQRCode', 'chooseImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表
                        });
                    })
                    .failed((code, message, data) => {
                        console.error(message);
                        layer.msg(message, function () { });
                    })
                    .error(err => {
                        console.error(err);
                        layer.msg(err, function () { });
                    })
                    .finally()
                    .request();
            }
            document.body.appendChild(wx_script);
        },
        checkAccount()
        {
            const hash = window.location.hash;
            const urlParams = new URLSearchParams(window.location.search);
            const switchAccountId = urlParams.get('switchId');// 账户切换switchId、switchMchId
            const switchAccountMchId = urlParams.get('switchMchId');
            if (!switchAccountId || this.$work_ctx.userId == switchAccountId) {
                return;
            }

            if (!hash)
            {
                window.location.href = `${this.$work_ctx.authHost}MchH5?mchId=${switchAccountMchId}&return_url=${encodeURIComponent(window.location.href)}`;
                return;
            }

            // 获取表单数据
            var openId = hash.replace("#", "");
            let formData = new FormData();
            formData.append("MemberId", switchAccountId);
            formData.append("MerchantId", switchAccountMchId);
            formData.append("OpenId", openId);
            // 发送表单数据到服务器
            fetch(this.$api.build('/My/SwitchAccount'), {
                method: "POST",
                body: formData
            })
            .then(res => {
                console.log("提交成功", res, res.ok);
                if (res.ok) {
                    window.location.reload();
                    return;
                }

                // layer.msg(`切换失败[${res.Response}]！`);
            })
            .catch(error => {
                console.error("提交失败", error);
            });
        },
        async init() {
            const pro1 = this.getMemberCarList();
            const pro2 = this.getMerchantInfo();
            
            Promise.all([pro1,pro2]).then((res)=>{
                this.flag = true;
                // console.log('~~~promise.all~~~', res);
                if(res[0].length > 0){
                    this.$store.commit('updateCarList', res[0]);
                    if(res[0].some(x=>x.isDefault)){
                        this.$store.commit('updateDefaultCar', res[0].find(x=>x.isDefault))
                    }else{
                        this.$store.commit('updateDefaultCar', res[0][0])
                    }
                    this.getMallShoppingCar();
                }else{
                    // layer.msg('未添加车辆', ()=>{});
                    this.$store.commit('updateCarList', []);
                    this.$store.commit('updateDefaultCar', null);
                }
                this.$store.commit('updateMerchantInfo', res[1])
                
                if(this.$store.state.temMerchantInfo){
                    if(this.$work_ctx.chainStores.some(x => x.subMerchantId != this.$store.state.temMerchantInfo.id)){
                        this.$store.commit('updateTemMerchant', null)
                    }
                }

            }).catch((err)=>{
                if(err instanceof Object){
                    console.error(err)
                }else{
                    layer.msg(err, ()=>{})
                }
            })
            
        },

        // 获取用户车辆列表
        getMemberCarList() {
            return new Promise((resolve,reject)=>{
                this.$http.get('/MemberVehicle/GetMemberVehicleList')
                    .success((message, data) => {
                        resolve(data)
                    })
                    .failed((code, message, data) => {
                        reject(message)
                    })
                    .error(err => {
                        reject(err)
                    })
                    .request()
            })
        },

        // 获取当前门店信息
        getMerchantInfo() {
            return new Promise((resolve, reject)=>{
                this.$http.get('/Merchant/GetById')
                    .success((message, data) => {
                        resolve(data)
                    })
                    .failed((code, message, data) => {
                        reject(message)
                    })
                    .error(err => {
                        reject(err)
                    })
                    .request()
            })
        },

        // 获取商城购物车
        getMallShoppingCar(){
            this.$http.get('/api/MallCart/GetMallCart')
            .setParameters({
                carModelId: this.$store.state.defaultCar.carId,
                vehicleId: this.$store.state.defaultCar.id
            })
            .success((message, data) => {
                // console.log('~~商城购物车~~', data);
                this.$store.state.mallCartCount = data.totalCount;
            })
            .failed((code, message, data) => {
                layer.msg('failed：' + message, () => {
                });
            })
            .error(err => {
                console.error(err)
            })
            .request()
        },
        
        handleFontSize() {
            // 设置网页字体为默认大小
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
            // 重写设置网页字体大小的事件
            WeixinJSBridge.on('menu:setfont', function () {
                WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
            });
        },


        // 关闭车辆完善弹框
        confirmPerfectVehicle(){
            this.$http.get('/MemberVehicle/GetMemberVehicleList')
                .success((message, data) => {
                    /*this.$store.commit('updateCarList', data);
                    if (data.length > 0) {
                        this.$router.go(0)
                    }*/
                    console.log('ss', data);
                    if(data.length > 0){
                        this.init();
                        this.$router.push({
                            name: 'Portal'
                        })
                    }
                    // this.$router.go(0)
                })
                .failed((code, message, data) => {
                    layer.msg(message, () => {
                    })
                })
                .error(err => {
                    console.error(err)
                })
                .request()
        },
    }

}

</script>

<style lang="scss">

html, body {
    overflow: visible;
    background-color: #f6f6f6;
}

</style>
